import React, { useContext, useEffect, useState } from 'react';
import { StyledModal } from './stars.style.js';
import RateForm from './RateForm';
import GoodRateForm from './GoodRateForm.js';
import FixelDataContext from "../../context/FixelDataContext";
import BadRateForm from './BadRateForm.js';
import axios from "axios";
import {formDataFromObj, wpUrl} from "../../services/globalService";
import {useCustomer} from "../../provider/customerProvider";

const RatingModal = ({ show }) => {
	const {customer} = useCustomer();
	const { fullFixelData } = useContext(FixelDataContext);
	const [isOpen, setIsOpen] = useState(true);
	const [opacity, setOpacity] = useState(0);
	const [showBtn, setShowBtn] = useState(false);
	const [showRateForm, setShowRateForm] = useState(true);
	const [showGoodRateForm, setShowGoodRateForm] = useState(false);
	const [showBadRateForm, setShowBadRateForm] = useState(false);
	const [rank, setRank] = useState(0);
	const [feedback, setFeedback] = useState('');
	const integromatUrl = 'https://hook.integromat.com/836brnwvk9qeehorfw0uosb26qebbpaj';


	useEffect(() => {
		setOpacity(0);
		setIsOpen(true);
	}, [show]);
	useEffect(() => {
		if (rank > 0) setShowBtn(true);
	}, [rank]);

	const afterOpen = () => {
		setTimeout(() => {
			setOpacity(1);
		}, 100);
	};
	const beforeClose = () => {
		return new Promise((resolve) => {
			setOpacity(0);
			setTimeout(resolve, 1000);
		});
	};
	const onPopupClose = () => {
		if (fullFixelData && fullFixelData.code) {
			localStorage.setItem('rateLaterTimestamp', +new Date());
		}
		setIsOpen(false);
	};
	const display = fullFixelData.display;

	const sendRating = async () => {
		const rating = {
			display,
			email: customer.email,
			rating: rank,
			review: feedback,
		};

		const ratingFormData = formDataFromObj({action: 'fxl_submit_rating',...rating})
		try {
			await axios.post(wpUrl, ratingFormData)
			await axios.post(integromatUrl, rating);
			localStorage.setItem('finishedRating', fullFixelData.code);
			setShowBadRateForm(false);
		}catch (e) {
			console.error('TCL ~ file: RatingModal.js ~ sendRating ~ error', e);
		}
	};
	const onFeedbackSubmit = async (e) => {
		e.preventDefault();
		await sendRating();
		setShowBadRateForm(false);
	};
	const onRatingSubmit = async (e) => {
		e.preventDefault();
		setShowRateForm(false);
		if (rank > 3) {
			await sendRating();
			setShowGoodRateForm(true);
		} else {
			setShowBadRateForm(true);
		}
	};

	return (
		<div>
			<StyledModal isOpen={isOpen} afterOpen={afterOpen} beforeClose={beforeClose} opacity={opacity} backgroundProps={{ opacity }}>
				{showRateForm && <RateForm showBtn={showBtn} onClose={onPopupClose} onSubmit={onRatingSubmit} rank={rank} setRank={setRank} />}
				{showGoodRateForm && <GoodRateForm onClose={onPopupClose} />}
				{showBadRateForm && <BadRateForm onClose={onPopupClose} onSubmit={onFeedbackSubmit} feedback={feedback} setFeedback={setFeedback} sendRating={sendRating} />}
			</StyledModal>
		</div>
	);
};
export default RatingModal;
